export interface DeliveryStatus {
  id: number;
  name: string | null;
}

export enum DeliveryStatusEnum {
  InProcess = 1,
  Submitted = 2,
  Approved = 3,
  Invoiced = 4,
  Canceled = 5,
}
